import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const EyeIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        preserveAspectRatio="none"
        viewBox="0 0 22 22"
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.533 6.217c-2.23-1.918-4.845-3.008-7.398-3.008s-5.168 1.09-7.398 3.008C1.91 7.787.593 9.739.593 11c0 1.262 1.318 3.214 3.144 4.784 2.231 1.918 4.845 3.008 7.398 3.008s5.168-1.09 7.398-3.008c1.826-1.57 3.144-3.522 3.144-4.784 0-1.261-1.318-3.213-3.144-4.783ZM4.618 7.227c1.999-1.72 4.31-2.683 6.517-2.683 2.208 0 4.518.963 6.517 2.682 1.558 1.34 2.679 3 2.679 3.774s-1.121 2.434-2.68 3.774c-1.998 1.719-4.308 2.682-6.516 2.682s-4.517-.963-6.517-2.682c-1.558-1.34-2.679-3-2.679-3.774s1.12-2.434 2.679-3.774Zm6.492-.46c2.352 0 4.265 1.899 4.265 4.233 0 2.334-1.913 4.232-4.265 4.232-2.352 0-4.265-1.898-4.265-4.232 0-2.334 1.913-4.232 4.265-4.232ZM8.19 11c0-1.596 1.311-2.897 2.92-2.897s2.92 1.3 2.92 2.897c0 1.597-1.311 2.897-2.92 2.897S8.19 12.597 8.19 11Z"
          fill="inherit"
        />
      </svg>
    );
  }
);
export default EyeIcon;
